export const TOP_NAV_HEIGHT: number = 64;
